"use client";
import { JSX } from "react";
import EmblaSlider from "../../lib/Embla-slider";
import { TSlideWidith } from "../../lib/Embla-slider/EmblaSliderContainer";
import useIsClient from "@/hooks/useIsClient";
import { useIsMobile } from "@/hooks/useIsMobile";
import { carouselSpeed } from "@/utils/functions/functions";

interface Props extends React.PropsWithChildren {
  customize?: any;
}

const BlogsCarousel: React.FC<Props> = ({ children, customize }) => {
  const isClient = useIsClient();
  const mobile = useIsMobile();

  const advanceMode = isClient && customize?.advance_mode;
  const slideWidth = advanceMode
    ? mobile
      ? customize?.width_mobile
      : customize?.width
    : 304; // default blog card width is 304px

  const gap = advanceMode
    ? mobile
      ? customize?.gap_mobile || 24
      : customize?.gap || 24
    : 24;

  const speed = carouselSpeed(customize?.interval);
  const autoPlay = !!speed && speed > 0;

  const data = (children as Array<JSX.Element>) ?? [];
  if (data.length === 0) return null;

  if (!isClient) {
    return (
      <div className="skeleton-rect" style={{ width: "100%", height: 320 }} />
    );
  }

  return (
    <EmblaSlider autoPlay={autoPlay} autoplayDuration={speed ?? 0}>
      <EmblaSlider.EmblaSliderViewport>
        <EmblaSlider.EmblaSliderContainer
          gap={gap}
          extraClassName="blog-carousel"
          slides={[
            ...(children as Array<JSX.Element>)?.map((child) => ({
              component: <div style={{ width: slideWidth, display: "flex", height: "100%" }}>{child}</div>,
              width: "auto" as TSlideWidith,
            })),
          ]}
        />
        <EmblaSlider.EmblaFilters />
        {data?.length > 3 ? <EmblaSlider.EmblaSliderPrevNextButtons /> : <></>}
      </EmblaSlider.EmblaSliderViewport>
    </EmblaSlider>
  );
};

export default BlogsCarousel;
